<template>
  <div class="sidebar d--f fd--c ai--c pt-40px">
    <span class="logo ai--c mt-20px"> SC </span>
    <nav class="d--f fd--c f--1 mt-40px">
      <router-link
        v-for="(item, index) in menuItems"
        :key="index"
        :to="item.route"
        :class="itemClass(item, index)"
        :aria-label="item.tooltip"
      >
        <ElTooltip :content="item.tooltip" placement="right" :show-after="200" :enterable="false" :teleported="false">
          <AppIcon :type="item.icon" size="30" class="sidebar-item pa-10px" />
        </ElTooltip>
      </router-link>
    </nav>
  </div>
</template>

<script setup>
import { ElTooltip } from "element-plus";
import { AppIcon } from "@/components/ui";
import { useRouter } from "vue-router";
import { computed } from "vue";

import { getMenuItems } from "@/utilities/collections/sidebar";
import { getCurrentUser } from "@/utilities/token";

const router = useRouter();

const menuItems = computed(() => {
  const currentUser = getCurrentUser();
  return getMenuItems(currentUser?.role);
});

const isActive = (route) => {
  return router.currentRoute.value.name === route.name;
};

const itemClass = (item, index) => [
  "sidebar-item-container d--f fd--c ai--c mb-20px br-10px",
  isActive(item.route) ? "active" : "",
  index === menuItems.value.length - 1 ? "mt--a mb-20px" : "",
];
</script>

<style lang="scss" scoped>
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 80px;
  height: 100vh;
  background-color: $color-primary;

  .logo {
    font-size: 26px;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: $color-white;
  }

  .sidebar-item-container {
    text-decoration: none;
    transition: background-color 150ms ease-out;

    .sidebar-item {
      color: $color-white;
    }

    &:hover {
      background-color: rgba($color-white, 0.14);
    }

    &:focus-visible {
      outline: 2px solid $color-white;
      outline-offset: 2px;
    }

    &.active {
      background-color: $color-white;

      .sidebar-item {
        color: $color-primary;
      }
    }
  }
}
</style>
